import { AgencyProfile } from '@/types-agency';
import { Language } from '@smg-real-estate/hg-rets-schema';

const MEDIA_BASE_URL = 'https://media.homegate.ch';

// We currently support cantons in Switzerland
export const supportedStates = [
  'AG',
  'AR',
  'AI',
  'BL',
  'BS',
  'BE',
  'FR',
  'GE',
  'GL',
  'GR',
  'JU',
  'LU',
  'NE',
  'NW',
  'OW',
  'SG',
  'SH',
  'SZ',
  'SO',
  'TI',
  'TG',
  'UR',
  'VD',
  'VS',
  'ZG',
  'ZH',
];

export function getBannerImageByState(state?: string): string {
  if (state && supportedStates.includes(state)) {
    return `${MEDIA_BASE_URL}/agency-profiles/${state}.jpg`;
  }

  return `${MEDIA_BASE_URL}/agency-profiles/default.jpg`;
}

export function getDefaultAgencyProfile(): AgencyProfile {
  return {
    customerId: '',
    customerName: '',
    address: {
      country: null,
      state: null,
      postalCode: null,
      city: null,
      street: null,
    },
    contact: {
      phone: null,
      website: null,
      language: Language.De,
    },
    isPremiumAgency: false,
    descriptions: { en: '' },
    services: [],
    specializations: [],
    logo: '',
  };
}

export enum MutationTypes {
  SET_AGENCY_PROFILE = 'setAgencyProfile',
  SET_AGENCY_AGENTS = 'setAgencyAgents',
  SET_PROFILE_API_STATUS = 'setProfileApiStatus',
  SET_AGENTS_API_STATUS = 'setAgentsApiStatus',
}
